<div *ngIf="this.aparecerNoticia" class="boxContainer">
  <div class="news-grid row">
    <div class="header row">
      <div class="col-12">
        <span class="orange-detail"></span>
        <h2 *ngIf="this.aparecerNoticia" class="titulo">Últimas notícias</h2>
      </div>
    </div>

    <div class="news-carousel">
      <p-carousel [value]="paginatedItems" styleClass="custom-carousel" [numVisible]="4" [numScroll]="1" [circular]="true"  [responsiveOptions]="responsiveOptions" [autoplayInterval]="3000">

        <ng-template let-product pTemplate="item">
          <div class="product-item">
            <div class="product-item-content">
              <img *ngIf="product.imagem" [src]="product.imagem" class="news-item_image" />
              <div *ngIf="!product.imagem" class="no-image">
                <span class="no-image-text">{{ product.titulo }}</span>
              </div>
              <p class="news-title">{{ product.titulo }}</p>
            </div>
          </div>
        </ng-template>        
      
    </p-carousel>
    </div>
  </div>